import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultDealersAddressData, getDealersAddressesById, updateDealersAddresses, createDealersAddresses } from '@/api/dealers-addresses';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getQuery } from '@/utils';
import { getPincodes, getPincodeById } from '@/api/pincode';
import { createCity, getCities } from '@/api/locations/cities';
import { getStates } from '@/api/locations/states';
import { generateNewDealerCode } from '@/api/dealers';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultDealersAddressData);
    this.loading = false;
    this.cityListLoading = false;
    this.stateListLoading = false;
    this.cityList = [];
    this.stateList = [];
    this.dialogFormVisible = false;
    this.pincodeList = [];
    this.rules = {
      name: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }],
      line1: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      cityName: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      pincodeId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      gstNumber: {
        pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        message: 'Enter a valid GST number',
        trigger: 'blur'
      }
    };
    this.listQuery = {
      page: 1,
      limit: 40,
      code: undefined,
      name: undefined,
      enabled: true,
      countryId: 0,
      sort: 'name,ASC',
      filter: {
        code: '$contL',
        name: '$contL',
        enabled: '$eq',
        countryId: '$eq'
      }
    };
    this.form = {
      name: '',
      stateId: '',
      countryId: 1
    };
    this.formLabelWidth = '120px';
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    this.getStateList();
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultDealersAddressData);
      this.formData.dealerId = parseInt(this.$route.params && this.$route.params.dealerId);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getDealersAddressesById(id);
      // fetch pincode
      await this.getPincodeById(data.pincodeId);
      this.formData = data;
      // Just for test
      const title = this.formData.name;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async getPincodeList(query) {
    try {
      if (query && query.length > 2) {
        this.pincodeList = await getPincodes(getQuery({
          pincode: query,
          filter: {
            pincode: '$starts'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getStateList() {
    try {
      this.stateListLoading = true;
      this.listQuery.countryId = 1;
      const data = await getStates(getQuery(this.listQuery));
      this.stateList = data.data;
      this.stateListLoading = false;
    } catch (error) {
      this.stateListLoading = false;
    }
  }
  async getCityList(query = null) {
    try {
      if (query && query.length > 2) {
        this.cityListLoading = true;
        this.cityList = await getCities(getQuery({
          name: query,
          filter: {
            name: '$contL'
          }
        }));
      }
      this.cityListLoading = false;
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getPincodeById(pincodeId) {
    try {
      if (pincodeId) {
        const data = await getPincodeById(pincodeId);
        this.pincodeList = [data];
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async updateLocation(pincodeId) {
    if (pincodeId) {
      const pincode = await getPincodeById(pincodeId);
      this.formData.pincodeId = pincode.id;
      this.formData.pincode = {
        id: pincode.id
      };
      this.formData.cityId = pincode.cityId;
      this.formData.city = {
        id: pincode.cityId
      };
      this.formData.stateId = pincode.stateId;
      this.formData.state = {
        id: pincode.stateId
      };
      this.formData.countryId = pincode.countryId;
      this.formData.country = {
        id: pincode.countryId
      };
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitDialog() {
    if (!this.form.name && !this.form.stateId) {
      this.$message({
        message: 'Either State or City name is required',
        type: 'warning'
      });
      return false;
    }
    if (this.form.name) {
      const trimmedName = this.form.name.trim();
      this.form.name = trimmedName.charAt(0).toUpperCase() + trimmedName.slice(1).toLowerCase();
    }
    this.saveDialog();
  }
  async saveDialog() {
    try {
      this.loading = true;
      this.form.countryId = 1;
      await createCity(this.form);
      this.loading = false;
      this.dialogFormVisible = false;
      this.$notify({
        title: 'Success',
        message: 'City saved',
        type: 'success',
        duration: 2000
      });
      this.form.name = '', this.form.stateId = '';
    } catch (error) {
      this.loading = false;
    }
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      let response;
      this.loading = true;
      this.formData.dealer = {
        id: this.formData.dealerId
      };
      await this.updateLocation(this.formData.pincodeId);
      if (this.isEdit) {
        response = await updateDealersAddresses(this.formData.id, this.formData);
      } else {
        response = await createDealersAddresses(this.formData);
      }
      if (response.isPrimary) {
        // create or update dealerCode
        await generateNewDealerCode({
          dealerId: response.dealerId
        });
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Address saved',
        type: 'success',
        duration: 2000
      });
      router.push(`/dealers-addresses/list/${this.formData.dealerId}`);
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveDialog", null);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'DealersAddressDetail',
  components: {}
})], default_1);
export default default_1;